var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tooltip',{attrs:{"content":_vm.value,"disabled":_vm.tooltipDisabled,"placement":"top-start"}},[_c('span',{ref:"content",on:{"mouseover":_vm.isShowTooltip}},[_vm._v(_vm._s(_vm.subValue))])])}
var staticRenderFns = []

export { render, staticRenderFns }